import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=65a1f789&scoped=true&"
import script from "./audit.vue?vue&type=script&lang=js&"
export * from "./audit.vue?vue&type=script&lang=js&"
import style0 from "./audit.vue?vue&type=style&index=0&id=65a1f789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1f789",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a1f789')) {
      api.createRecord('65a1f789', component.options)
    } else {
      api.reload('65a1f789', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=65a1f789&scoped=true&", function () {
      api.rerender('65a1f789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/goods/components/audit.vue"
export default component.exports